import React from 'react';
import { DebugItem } from '../../types/IAiConversation';

// The SQL behind a `run_sql` tool call, when the API sends it as a JSON `{ sql }` input.
const sqlOf = (item: DebugItem): string | null => {
  if (item.kind !== 'tool_call' || !item.input) return null;
  try {
    const parsed = JSON.parse(item.input) as { sql?: unknown };
    return typeof parsed.sql === 'string' ? parsed.sql : null;
  } catch {
    return null;
  }
};

// "(7 rows, 41 ms)" or "(200 of more rows, TRUNCATED ...)": the row count from a result footer.
const rowCountOf = (result?: string): number | null => {
  const match = result?.match(/\((\d+)(?: of (?:more|\d+))? rows?\b/);
  return match ? Number(match[1]) : null;
};

export const describeDebug = (item: DebugItem): string => {
  if (item.kind === 'tool_call')
    return item.tool === 'run_sql' ? 'Query' : item.tool;
  if (item.result?.startsWith('ERROR:')) return 'Result · error';
  const rows = rowCountOf(item.result);
  return rows == null
    ? 'Result'
    : `Result · ${rows} row${rows === 1 ? '' : 's'}`;
};

interface IProps {
  items: DebugItem[];
}

// What the assistant asked the database and what came back. Only rendered when the API runs
// in debug mode (it is the only time these items exist). Collapsed by default.
const DebugBlock = ({ items }: IProps) => (
  <>
    {items.map((item, index) => {
      const sql = sqlOf(item);
      const body = sql ?? item.input ?? item.result ?? '';
      return (
        // eslint-disable-next-line react/no-array-index-key
        <details key={index} className="chat-debug">
          <summary>{describeDebug(item)}</summary>
          <pre>{body}</pre>
        </details>
      );
    })}
  </>
);

export default DebugBlock;
